import { render } from "./PromotionSection.vue?vue&type=template&id=1752486c"
import script from "./PromotionSection.vue?vue&type=script&lang=js"
export * from "./PromotionSection.vue?vue&type=script&lang=js"

import "./PromotionSection.vue?vue&type=style&index=0&id=1752486c&lang=css"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__